<template>
	<div class="pa-2 pb-0">
		<v-row
			align="center"
			dense
			class="mb-1">
			<v-spacer></v-spacer>
			<v-col cols="auto">
				<v-btn
					@click="addAttendanceDialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
		</v-row>

		<bee-handy-table
			:headers="tableHeaders"
			:items="loading ? [] : items"
			:data-table-props="{ disableSort: true }"
			:loading="loading"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 120"
			hide-default-footer>
			<template v-slot:item.name="{ item }">
				<!-- === ? attendanceTypeEnum.regular : attendanceTypeEnum.hourly -->
				<tooltip
					text="يومي"
					v-if="item.type === attendanceTypeEnum.regular">
					<v-icon class="me-1">mdi-calendar-week</v-icon>
				</tooltip>
				<tooltip
					text="ساعي"
					v-if="item.type === attendanceTypeEnum.hourly">
					<v-icon class="me-1">mdi-calendar-clock</v-icon>
				</tooltip>

				<tooltip
					text="هجين"
					v-if="item.type === attendanceTypeEnum.hybrid">
					<v-icon class="me-1">mdi-calendar-clock</v-icon>
				</tooltip>
				{{ item.name }}
			</template>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon
							@click="
								attendanceTypeDialog = true;
								selectedItem = item;
							">
							<v-icon
								size="20"
								color="preview">
								$view
							</v-icon>
						</v-btn>
					</tooltip>
					
					<tooltip :text="$T('tooltips.edit')">
						<v-btn
							small
							icon
							@click="editAttendanceType(item)">
							<v-icon
								size="20"
								color="edit-color">
								$edit
							</v-icon>
						</v-btn>
					</tooltip>

					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							small
							icon
							@click="
								deleteDialog = true;
								selectedItem = item;
							">
							<v-icon
								size="20"
								color="alert-color">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
				</div>
			</template>
		</bee-handy-table>

		<!-- add attendance type -->
		<v-dialog
			v-model="addAttendanceDialog"
			persistent
			:max-width="attendanceType !== attendanceTypeEnum.hourly 
				? attendanceType === attendanceTypeEnum.regular ? 1050 : 1150 
				: 450"
			:transition="false"
		>
			<v-card elevation="3">
				<v-form>
					<v-card-title primary-title>
						{{ $T('addType.title') }}
						<v-spacer></v-spacer>
						<v-btn
							@click="
								addAttendanceDialog = false;
								clearAddingAttendanceType();
							"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-card elevation="0" 
							:class="{ 'scroll-dialog-style': attendanceType !== attendanceTypeEnum.hourly }">
							<v-row>
								<v-col :cols="attendanceType !== attendanceTypeEnum.hourly ? 6 : 12">
									<!-- attendance type -->
									<v-radio-group
										v-model="attendanceType"
										mandatory
										dense
										row
										class="mt-0 mb-2"
										hide-details>
										<v-radio
											:label="$T('addType.daily')"
											:value="attendanceTypeEnum.regular"></v-radio>
										<v-radio
											:label="$T('addType.hourly')"
											:value="attendanceTypeEnum.hourly"></v-radio>

										<v-radio
											:label="$T('addType.hybrid')"
											:value="attendanceTypeEnum.hybrid"></v-radio>
									</v-radio-group>
									<!-- daily -->
									<v-row
										v-if="attendanceType !== attendanceTypeEnum.hourly"
										dense
										justify="center">
										<!-- attendance name -->
										<v-col cols="12">
											<v-text-field
												v-model="attendanceName"
												class="mb-3"
												:label="$T('addType.name')"
												:error="inValid.includes(invalidEnum.name)"
												outlined
												dense
												hide-details></v-text-field>
										</v-col>
										<!-- attendance timing -->
										<template v-for="(_, i) in 7">
											<!-- day of the week -->
											<v-col
												cols="3"
												:key="i + '1'">
												<v-checkbox
													v-model="weekDay[i].active"
													class="mt-0"
													:class="{
														'font-weight-bold': weekDay[i].active,
													}"
													dense
													:label="moment().day(i).format('dddd')"
													@change="calcTimes"></v-checkbox>
											</v-col>
											<!-- from time -->
											<v-col
												cols="4"
												:key="i + '2'">
												<!-- inValid.includes(invalidEnum.time) && -->
												<v-text-field
													v-model="weekDay[i].from"
													:disabled="!weekDay[i].active"
													@change="calcTimes"
													@focus="recommend(i)"
													:label="$T('from')"
													:error="weekDayTimeOrderIsWrong[i]"
													type="time"
													outlined
													dense
													hide-details></v-text-field>
											</v-col>
											<!-- to time -->
											<v-col
												cols="4"
												:key="i + '3'">
												<!-- inValid.includes(invalidEnum.time) && -->
												<v-text-field
													v-model="weekDay[i].to"
													:disabled="!weekDay[i].active"
													@change="calcTimes"
													@focus="recommend(i)"
													:label="$T('to')"
													:error="weekDayTimeOrderIsWrong[i]"
													type="time"
													outlined
													dense
													hide-details></v-text-field>
											</v-col>
											<!-- duration -->
											<v-col
												cols="1"
												:key="i + '4'">
												<span
													:class="{
														'error--text': weekDayTimeOrderIsWrong[i],
													}">
													{{ weekDay[i].duration || '--:--' }}
												</span>
											</v-col>
										</template>
										
										<!-- total hours -->
										<v-col cols="11"></v-col>
										<v-col cols="1"> {{ totalDuration || '--:--' }} </v-col>
									</v-row>
									
									<!-- hourly -->
									<v-row
										v-else
										dense>
						
										<!-- name -->
										<v-col cols="6">
											<v-text-field
												v-model="attendanceName"
												class="mb-3"
												:label="$T('addType.name')"
												:error="inValid.includes(invalidEnum.name)"
												outlined
												dense
												hide-details></v-text-field>
										</v-col>
										<!-- hours count -->
										<v-col cols="6">
											<v-text-field
												v-model="attendanceWeeklyDuration"
												class="mb-3"
												:label="$T('addType.hoursNumber')"
												:error="inValid.includes(invalidEnum.time)"
												outlined
												dense
												hide-details></v-text-field>
										</v-col>
									</v-row>
								</v-col>
								<v-divider
									vertical
									v-if="attendanceType !== attendanceTypeEnum.hourly"></v-divider>
								
								<!-- hybrid -->
								<v-col v-if="attendanceType === attendanceTypeEnum.hybrid" cols="6 ">
									<v-row dense>
										<template v-for="(_, j) in 7">
											<v-col
												cols="2"
												:key="j + '5'">
												<v-checkbox
													v-model="hybridSystemsDay[j].active"
													class="mt-0"
													:class="{
														'font-weight-bold': hybridSystemsDay[j].active,
													}"
													dense
													:label="moment().day(j).format('dddd')"
													hide-details
												></v-checkbox>
											</v-col>

											<!-- count hour -->
											<v-col
												cols="5"
												:key="j + '6'">
												<v-text-field
													v-model="hybridSystemsDay[j].hoursOnDay"
													:disabled="!hybridSystemsDay[j].active"
													:label="$t('AddAttendanceType.hours-on-day')"
													:error="weekDayTimeOrderIsWrong[j]"
													outlined
													type="number"
													hide-spin-buttons
													dense
													hide-details></v-text-field>
											</v-col>
											<!-- to time -->
											<v-col
												cols="5"
												:key="j + '7'">
											
												<v-text-field
													v-model="hybridSystemsDay[j].minimumWorkHours"
													:disabled="!hybridSystemsDay[j].active"
													:label="$T('AddAttendanceType.minimum-work-hours')"
													:error="weekDayTimeOrderIsWrong[j]"
													outlined
													dense
													hide-details></v-text-field>
											</v-col>
											<!-- workDeadlineHours -->
											<v-col
												cols="12"
												:key="j + '8'">
												<v-text-field
													v-model="hybridSystemsDay[j].workDeadlineHours"
													:disabled="!hybridSystemsDay[j].active"
													:label="$T('AddAttendanceType.work-deadline-hours')"
													:error="weekDayTimeOrderIsWrong[j]"
													outlined
													dense
													hide-details></v-text-field>
													<!-- @focus="recommend(j)" -->
											</v-col>
										</template>
									</v-row>
								</v-col>
								<v-col
									:cols="attendanceType === attendanceTypeEnum.regular ? '5' : '12'"
									v-if="attendanceType !== attendanceTypeEnum.hourly">
									<v-row>
										<v-col cols="6">
											<div class="text-body-1 mb-2">{{ $T('addType.late') }}</div>
											<v-text-field
												class="hint-end"
												v-model="attendanceDetails.late.duration"
												:label="$T('addType.allowedTime')"
												:hint="$T('addType.inMinute')"
												persistent-hint
												outlined
												dense></v-text-field>

											<v-text-field
												v-model="attendanceDetails.late.value"
												:label="$T('addType.subtract')"
												outlined
												dense
												hide-details>
											</v-text-field>
											<div class="d-flex justify-end mt-1">
												<v-btn-toggle
													color="primary"
													mandatory
													v-model="attendanceDetails.late.isStatic"
													dense>
													<v-btn
														x-small
														:value="true">
														{{ $T('addType.static') }}
													</v-btn>
													<v-btn
														x-small
														:value="false">
														{{ $T('addType.percentage') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-col>
										<v-col cols="6">
											<div class="text-body-1 mb-2">{{ $T('addType.earlyLeave') }}</div>
											<v-text-field
												class="hint-end"
												v-model="attendanceDetails.earlyLeave.duration"
												:label="$T('addType.allowedTime')"
												:hint="$T('addType.inMinute')"
												persistent-hint
												outlined
												dense></v-text-field>

											<v-text-field
												v-model="attendanceDetails.earlyLeave.value"
												:label="$T('addType.subtract')"
												outlined
												dense
												hide-details>
											</v-text-field>
											<div class="d-flex justify-end mt-1">
												<v-btn-toggle
													color="primary"
													mandatory
													v-model="attendanceDetails.earlyLeave.isStatic"
													dense>
													<v-btn
														x-small
														:value="true">
														{{ $T('addType.static') }}
													</v-btn>
													<v-btn
														x-small
														:value="false">
														{{ $T('addType.percentage') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-col>

										<v-col cols="6">
											<div class="text-body-1 mb-2">{{ $T('addType.extra') }}</div>
											<v-text-field
												class="hint-end"
												v-model="attendanceDetails.extra.minDuration"
												:label="$T('addType.extraStart')"
												:hint="$T('addType.inMinute')"
												persistent-hint
												outlined
												dense></v-text-field>

											<v-text-field
												v-model="attendanceDetails.extra.maxDuration"
												:label="$T('addType.extraMax')"
												outlined
												dense
												hide-details>
											</v-text-field>
											<div class="d-flex justify-end mt-1 mb-3">
												<v-btn-toggle
													color="primary"
													mandatory
													v-model="attendanceDetails.extra.maxDurationAsDay"
													dense>
													<v-btn
														x-small
														:value="true">
														{{ $T('addType.minInDay') }}
													</v-btn>
													<v-btn
														x-small
														:value="false">
														{{ $T('addType.hourInMonth') }}
													</v-btn>
												</v-btn-toggle>
											</div>

											<v-text-field
												v-model="attendanceDetails.extra.value"
												:label="$T('addType.extraValue')"
												outlined
												dense
												hide-details>
											</v-text-field>
											<div class="d-flex justify-end mt-1">
												<v-btn-toggle
													color="primary"
													mandatory
													v-model="attendanceDetails.extra.isStatic"
													dense>
													<v-btn
														x-small
														:value="true">
														{{ $T('addType.static') }}
													</v-btn>
													<v-btn
														x-small
														:value="false">
														{{ $T('addType.percentage') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-col>
										<v-col cols="6">
											<div class="text-body-1 mb-2">{{ $T('addType.absent') }}</div>
											<v-text-field
												class="hint-end"
												v-model="attendanceDetails.absent.value"
												:label="$T('addType.subtract')"
												outlined
												dense
												hide-details>
											</v-text-field>
											<div class="d-flex justify-end mt-1">
												<v-btn-toggle
													color="primary"
													mandatory
													v-model="attendanceDetails.absent.isStatic"
													dense>
													<v-btn
														x-small
														:value="true">
														{{ $T('addType.static') }}
													</v-btn>
													<v-btn
														x-small
														:value="false">
														{{ $T('addType.percentage') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>

						<v-btn
							color="secondary"
							:loading="loadingAdding"
							:disabled="loadingAdding"
							@click="
								attendanceType === attendanceTypeEnum.regular
									? AddDailyAttendance()
									: attendanceType === attendanceTypeEnum.hourly ? AddHourlyAttendance() : AddHybridAttendance()
							">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- attendance dialog -->
		<v-dialog
			v-model="attendanceTypeDialog"
			:max-width="450"
			transition="dialog-transition">
			<v-card
				elevation="3"
				v-if="selectedItem">
				<v-card-title primary-title>
					نظام الدوام
					<v-spacer></v-spacer>
					<v-btn
						@click="attendanceTypeDialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<div class="text-h6 mb-3">{{ selectedItem.name }}</div>
					<template v-if="selectedItem.type === attendanceTypeEnum.daily">
						<v-row
							dense
							v-for="item in selectedItem.dailySystems"
							:key="item.day">
							<v-col cols="6">{{ moment().day(item.day).format('dddd') }}</v-col>
							<v-col cols="6">
								{{ moment(item.startDate).format('hh:mm A') }} -
								{{ moment(item.endDate).format('hh:mm A') }}
							</v-col>
						</v-row>
						<v-divider class="my-3"></v-divider>
						<div
							v-for="item in [
								'allowedDelayInMinute',
								'delayDiscountStatic',
								'delayDiscountRate',
								'earlyDepartureInMinute',
								'earlyDiscountStatic',
								'earlyDiscountRate',
								'additionStartAfterInMinute',
								'maxOfAdditionPerDayInMinute',
								'additionValueStatic',
								'additionValueRate',
								'absenceDiscountStatic',
								'absenceDiscountRate',
							]"
							:key="item">
							<v-row v-if="selectedItem[item]">
								<v-col cols="6">{{ dialogText[item].name }} </v-col>
								<v-col cols="6">{{ selectedItem[item] }}{{ dialogText[item].unit }}</v-col>
							</v-row>
						</div>
					</template>
					<div v-else>
						عدد الساعات في الاسبوع:
						{{ selectedItem.hourlySystems.weeklyHoursCount }}
					</div>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						@click="attendanceTypeDialog = false">
						{{ $T('default-buttons.done') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'attendanceSystem/delete'"
			:parameters="{ id: selectedItem ? selectedItem.id : null }"
			@on-delete="fetchAttendanceTypes()">
			هل أنت متأكد من أنك تريد حذف هذا النوع من الدوام ؟
		</v-delete-dialog>
	</div>
</template>

<script>
import moment from 'moment';

const attendanceTypeEnum = {
	regular: 1, // regular is daily type
	hourly: 2,
	hybrid: 3
};

const invalidEnum = {
	name: 0,
	time: 1,
};

export default {
	name: 'AddAttendanceType',

	data() {
		return {
			loading: true,
			loadingAdding: false,

			addAttendanceDialog: false,
			attendanceTypeDialog: false,

			addAttendanceId: null,
			attendanceType: attendanceTypeEnum.regular,
			attendanceName: null,
			attendanceWeeklyDuration: null,
			weekDay: [
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
				{ from: null, to: null, active: false, duration: 0 },
			],
			hybridSystemsDay: [
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
				{ hoursOnDay: 0, minimumWorkHours: 0, workDeadlineHours: 0 },
			],
			weekDayTimeOrderIsWrong: [false, false, false, false, false, false, false],
			attendanceDetails: {
				late: {
					duration: '',
					value: '',
					percent: '',
					isStatic: true,
				},
				earlyLeave: {
					duration: '',
					value: '',
					isStatic: true,
				},
				absent: {
					value: '',
					isStatic: true,
				},
				extra: {
					minDuration: 0,
					maxDurationAsDay: true,
					maxDuration: '',
					value: '',
					isStatic: true,
				},
			},

			totalDuration: null,

			tableHeaders: [
				{ text: this.$T('table.name'), name: 'name', value: 'name' },
				{
					text: this.$T('table.totalHours'),
					name: 'dailySystems',
					value: 'dailySystems',
					setValueExpr: (v, i) => {
						if (this.items[i].type !== attendanceTypeEnum.daily)
							return this.items[i].hourlySystems.weeklyHoursCount + ':00';
						return this.calcTotalHours(
							v.map((e) => ({
								to: e.endDate.slice(11, 16),
								from: e.startDate.slice(11, 16),
							})),
						);
					},
				},
				{
					text: this.$T('table.vacations'),
					name: 'vacations',
					value: 'dailySystems',
					setValueExpr: (v, i) => {
						if (this.items[i].type !== attendanceTypeEnum.daily) return '-';
						const weekdays = new Set([0, 1, 2, 3, 4, 5, 6]);
						v.forEach((e) => {
							weekdays.delete(e.day);
						});
						return [...weekdays].map((e) => moment().day(e).format('dddd')).join(', ');
					},
				},
				{ text: '', name: 'actions', value: 'actions', width: 20 },
			],

			inValid: [],

			selectedItem: null,
			dialogText: {
				allowedDelayInMinute: { name: 'الوقت المسموح للتأخر', unit: 'د' },
				delayDiscountStatic: { name: 'الخصم عند التأخر', unit: 'ل.س' },
				delayDiscountRate: { name: 'الخصم عند التأخر', unit: 'من الراتب' },

				earlyDepartureInMinute: { name: 'الوقت المسموح للانصراف المبكر', unit: 'د' },
				earlyDiscountStatic: { name: 'الخصم عند الانصراف المبكر', unit: 'ل.س' },
				earlyDiscountRate: { name: 'الخصم عند الانصراف المبكر', unit: 'من الراتب' },

				additionStartAfterInMinute: { name: 'يبدأ احتساب الإضافي بعد', unit: 'د' },
				maxOfAdditionPerDayInMinute: { name: 'الحد الإقصى للإضافي', unit: 'د' },
				additionValueStatic: { name: 'الزيادة على الإضافي', unit: 'ل.س' },
				additionValueRate: { name: 'الزيادة على الإضافي', unit: 'من الراتب' },

				absenceDiscountStatic: { name: 'الخصم عند الغياب', unit: 'ل.س' },
				absenceDiscountRate: { name: 'الخصم عند الغياب', unit: 'من الراتب' },
			},

			attendanceTypeEnum,
			invalidEnum,
			items: [],
			deleteDialog: false
		};
	},

	watch: {
		attendanceType() {
			this.inValid = [];
		},
		addAttendanceDialog() {
			this.inValid = [];
		},
	},

	computed: {},

	methods: {
		fetchAttendanceTypes() {
			this.loading = true;
			this.$store.dispatch('attendance/fetchAttendanceTypes')
			.then((res) => {
				this.items = res;
			})
			.finally(() => {
				this.loading = false;
			});
		},

		AddHourlyAttendance() {
			this.inValid = [];
			if (!this.attendanceName) {
				this.inValid.push(invalidEnum.name);
			}
			if (!this.attendanceWeeklyDuration) {
				this.inValid.push(invalidEnum.time);
			}
			if (this.inValid.length) return;

			this.loadingAdding = true;
			this.$store
				.dispatch('attendance/addHourlyAttendanceType', {
					id: this.addAttendanceId,
					name: this.attendanceName,
					hoursCount: this.attendanceWeeklyDuration,
				})
				.then(() => {
					this.addAttendanceId !== null ? this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true }) : this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					this.addAttendanceDialog = false;
					this.fetchAttendanceTypes();
					this.clearAddingAttendanceType();
				})
				.catch((err) => {
					err.default && err.default(this.addAttendanceId !== null ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'), false);
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},
		AddDailyAttendance() {
			console.log(this.weekDay)
			this.inValid = [];
			if (!this.attendanceName) {
				this.inValid.push(invalidEnum.name);
			}
			// there is one wrong item aka. have true value
			if (this.weekDayTimeOrderIsWrong.reduce((p, a) => p || a, false)) {
				this.inValid.push(invalidEnum.time);
			}
			if (this.inValid.length) return;

			this.loadingAdding = true;
			this.$store
				.dispatch('attendance/addDailyAttendanceType', {
					id: this.addAttendanceId,
					name: this.attendanceName,
					...this.attendanceDetails,
					days: this.weekDay,
				})
				.then((res) => {
					if(this.addAttendanceId === null) {
						this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					} else {
						this.$eventBus.$emit('show-snackbar', this.$T('messages.edit-done'), { done: true });
					}
					this.addAttendanceDialog = false;
					this.fetchAttendanceTypes();
					this.clearAddingAttendanceType();
				})
				.catch((err) => {
					if(this.addAttendanceId === null) {
						err.default && err.default(this.$T('messages.add-fail'), false);
					} else {
						err.default && err.default(this.$T('messages.edit-fail'), false);
					}
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},

		AddHybridAttendance() {
			this.inValid = [];
			if (!this.attendanceName) {
				this.inValid.push(invalidEnum.name);
			}
			// there is one wrong item aka. have true value
			if (this.weekDayTimeOrderIsWrong.reduce((p, a) => p || a, false)) {
				this.inValid.push(invalidEnum.time);
			}
			if (this.inValid.length) return;

			this.loadingAdding = true;
			this.$store
				.dispatch('attendance/addHybridAttendanceType', {
					id: this.addAttendanceId,
					name: this.attendanceName,
					...this.attendanceDetails,
					days: this.weekDay,
					daysHybrid: this.hybridSystemsDay
				})
				.then((res) => {
					if(this.addAttendanceId === null) {
						this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					} else {
						this.$eventBus.$emit('show-snackbar', this.$T('messages.edit-done'), { done: true });
					}
					this.addAttendanceDialog = false;
					this.fetchAttendanceTypes();
					this.clearAddingAttendanceType();
				})
				.catch((err) => {
					if(this.addAttendanceId === null) {
						err.default && err.default(this.$T('messages.add-fail'), false);
					} else {
						err.default && err.default(this.$T('messages.edit-fail'), false);
					}
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},

		editAttendanceType(item) {
			this.addAttendanceId = item.id;
			this.addAttendanceDialog = true;
			// === ? attendanceTypeEnum.regular : attendanceTypeEnum.hourly
			this.attendanceType = item.type;
			this.attendanceName = item.name;
			this.attendanceWeeklyDuration = item.hourlySystems?.weeklyHoursCount;
			this.weekDay = [
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
			];
			this.hybridSystemsDay = [
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false },
				{ hoursOnDay: null, minimumWorkHours: null, workDeadlineHours: false }
			];
			item.dailySystems.forEach((e) => {
				this.weekDay[e.day] = {
					from: moment(e.startDate).format('HH:mm'),
					to: moment(e.endDate).format('HH:mm'),
					active: Boolean(e.startDate || e.endDate),
					duration: this.diff(moment(e.endDate), moment(e.startDate)),
				};
			});
			if(this.attendanceType === attendanceTypeEnum.hybrid) {
				item.hybridSystems.forEach((e) => {
					this.hybridSystemsDay[e.day] = {
						hoursOnDay: e.hoursOnDay,
						minimumWorkHours: e.minimumWorkHours,
						workDeadlineHours: e.workDeadlineHours,
						active: Boolean(e.hoursOnDay || e.minimumWorkHours || e.workDeadlineHours),
					}
				})
			}
			this.weekDayTimeOrderIsWrong = [false, false, false, false, false, false, false];
			this.attendanceDetails = {
				late: {
					duration: item.allowedDelayInMinute,
					value: item.delayDiscountStatic || item.delayDiscountRate,
					isStatic: Boolean(item.delayDiscountStatic),
				},
				earlyLeave: {
					duration: item.earlyDepartureInMinute,
					value: item.earlyDiscountStatic || item.earlyDiscountRate,
					isStatic: Boolean(item.earlyDiscountStatic),
				},
				absent: {
					value: item.absenceDiscountStatic || item.absenceDiscountRate,
					isStatic: Boolean(item.absenceDiscountStatic),
				},
				extra: {
					minDuration: item.additionStartAfterInMinute,

					maxDurationAsDay: Boolean(item.maxOfAdditionPerDayInMinute),
					maxDuration: item.maxOfAdditionPerDayInMinute || item.MaxOfAdditionPerMonthInHour,

					value: item.additionValueStatic || item.additionValueRate,
					isStatic: Boolean(item.additionValueStatic),
				},
			};
			this.calcTimeDuration();
		},
		clearAddingAttendanceType() {
			this.addAttendanceId = null;
			this.attendanceType = attendanceTypeEnum.regular;
			this.attendanceName = null;
			this.attendanceWeeklyDuration = null;
			this.weekDay = [
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
				{ from: null, to: null, active: false, duration: null },
			];
			this.weekDayTimeOrderIsWrong = [false, false, false, false, false, false, false];
			this.attendanceDetails = {
				late: {
					duration: '',
					value: '',
					isStatic: true,
				},
				earlyLeave: {
					duration: '',
					value: '',
					isStatic: true,
				},
				absent: {
					value: '',
					isStatic: true,
				},
				extra: {
					minDuration: '',
					maxDurationAsDay: true,
					maxDuration: '',
					value: '',
					isStatic: true,
				},
			};
			this.totalDuration = null;
		},

		calcTimeDuration() {
			this.totalDuration = this.calcTotalHours(this.weekDay);
		},
		calcTimes() {
			for (let i = 0; i < this.weekDay.length; i++) {
				const day = this.weekDay[i];

				this.weekDayTimeOrderIsWrong[i] = false;
				this.weekDay[i].duration = null;

				if (!day.active) {
					this.weekDay[i].from = this.weekDay[i].to = null;
					continue;
				}
				if (day.to && day.from && !moment(day.to, 'hh:mm').isAfter(moment(day.from, 'hh:mm'))) {
					this.weekDayTimeOrderIsWrong[i] = true;
				} else {
					this.weekDay[i].duration = this.diff(moment(day.to, 'hh:mm'), moment(day.from, 'hh:mm'));
				}
			}

			this.calcTimeDuration();
		},

		// utils
		moment,
		/**
		 * @param {{from,to}[]} timing(hh:mm)
		 */
		calcTotalHours(timing) {
			let totalDiff = 0;

			timing.forEach((e) => {
				if (e && moment(e.to, 'hh:mm').isValid() && moment(e.from, 'hh:mm').isValid()) {
					const diff = moment(e.to, 'hh:mm').diff(moment(e.from, 'hh:mm'));
					if (diff > 0) {
						totalDiff += diff;
					}
				}
			});

			if (!totalDiff) return '--:--';

			const duration = moment.duration(totalDiff);

			return `${Math.floor(duration.as('h'))}:${
				duration.get('m') > 9 ? duration.get('m') : '0' + duration.get('m')
			}`;
		},
		recommend(index) {
			const firstEnterDay = this.weekDay.find((e) => e.from && e.to);

			if (!firstEnterDay) return;

			if (!this.weekDay[index].from && !this.weekDay[index].to) {
				this.weekDay[index].from = firstEnterDay.from;
				this.weekDay[index].to = firstEnterDay.to;
			}
		},
		deleteItem(index) {
			this.weekDay[index].from = null;
			this.weekDay[index].to = null;
		},
		diff(a, b) {
			if (!a.isValid() || !b.isValid()) return;
			const duration = moment.duration(a.diff(b));

			return `${duration.get('h') > 0 ? duration.get('h') : 0}:${
				duration.get('m') > 0
					? duration.get('m') > 9
						? duration.get('m')
						: '0' + duration.get('m')
					: '00'
			}`;
		},
	},

	mounted() {
		console.log(this.moment().format('hh:mm A'))
		this.fetchAttendanceTypes();
	},
};
</script>

<style lang="scss">
.hint-end .v-text-field__details .v-messages__message {
	text-align: end;
}
.scroll-dialog-style {
	height: 450px; 
	float:center;
	width: 100%; 
	overflow-y: auto
}
</style>

